export const fr = {
  add_a_circle: 'Ajouter un cercle',
  add_a_free_hand_shape: 'Ajouter une forme à main levée',
  add_a_line: 'Ajouter une ligne',
  add_a_rectangle: 'Ajouter un rectangle',
  add_an_arrow_shape: 'Ajouter une flèche',
  add_an_ellipse: 'Ajouter une ellipse',
  add_image_from_url: 'Ajouter une image à partir d\'une URL',
  anonymous: 'Anonyme',
  arrow: 'Flèche',
  border_color: 'Couleur de bordure',
  cancel: 'Annuler',
  circle: 'Cercle',
  click_on_canvas_to_write: 'Cliquer sur le canvas pour écrire du texte',
  click_to_delete_shape: 'Cliquer sur une forme pour la supprimer',
  container_size: 'Taille du conteneur',
  create_annotation: 'Créer une annotation',
  createdByOn: 'Créé par {{creator}}, {{creationDate}}',
  debugAnnotation: 'Voir l\'annotation dans la console',
  delete: 'Supprimer',
  deleteAnnotation: 'Supprimer',
  delete_all: 'Tout supprimer',
  detected_media_type: 'Nous détectons un média de type {{mediaType}}.',
  document: 'Document',
  drawings_and_text_in_overlay: 'Dessins et texte en superposition',
  edit: 'Éditer',
  edit_annotation: 'Editer l\'annotation',
  edit_iiif_json_code: 'Modifier directement le code JSON IIIF',
  ellipse: 'Ellipse',
  expert_mode: 'Mode expert',
  export_annotation: 'Exporter les annotations',
  export_annotation_for: 'Exporter les annotations pour {{label}}',
  export_local_annotation: 'Exporter les annotations locales pour les éléments visibles',
  fill_color: 'Couleur de remplissage',
  freehand: 'Main levée',
  image: 'Image',
  imageUrl: 'URL de l\'image',
  image_displayed: 'Image affichée',
  image_in_overlay_with_note: 'Image en superposition avec une note',
  image_true_size: 'Taille réelle de l\'image',
  invalid_url: 'URL invalide',
  lastEditedByOn: 'Dernière modification par {{lastEditor}}, {{lastSavedDate}}',
  line: 'Ligne',
  line_weight: 'Épaisseur de ligne',
  loading_failed: 'Échec du chargement',
  maev_github_link: 'https://github.com/SCENE-CE/mirador-annotation-editor-video',
  manifest_link: 'Lien vers un manifest',
  manifest_link_with_note: 'Manifest avec description',
  manifest_url: 'URL du manifeste',
  media_not_supported: 'Média non pris en charge',
  media_not_supported_text: 'Ce média n\'est pas encore supporté par cette instance.',
  metadata: 'Métadonnées',
  new_annotation: 'Nouvelle annotation',
  no_annotation: 'Aucune annotation enregistrée pour le moment.',
  note: 'Note',
  object_list: 'Liste des objets',
  onlyOneImageAllowed: 'Une seule image par annotation',
  overlay: 'Dessin',
  polygon: 'Polygone',
  pressEnterOrClickFirstPointToClose: 'Cliquez sur le premier point ou appuyez sur "Maj" pour fermer le polygone, "Tab" pour laisser ouvert',
  pressEnterToAddTag: 'Valider avec "Entrée"',
  pressEscapeToFinish: 'Appuyez sur "Échap" pour terminer la ligne',
  rectangle: 'Rectangle',
  save: 'Sauvegarder',
  scale: 'Échelle',
  select_cursor: 'Sélectionner le curseur',
  selected_object: 'Objet sélectionné',
  shape: 'Forme',
  shape_selection: 'Dessin de forme',
  shapes: 'Formes',
  spatialTarget: 'Formes',
  style: 'Style',
  style_selection: 'Sélection du style',
  switch_view: 'Passer à la vue simple',
  switch_view_content: 'Les annotations peuvent seulement être éditées en vue simple.\n'
    + 'Passer en vue simple simplement ?',
  switch_view_h2: 'Changer le type de vue en vue simple?',
  tag: 'Étiquette',
  tag_with_target: 'Étiquette avec cible',
  tags: 'Étiquettes',
  tagsPlaceholder: 'Ajouter une étiquette...',
  target: 'Cible',
  text: 'Texte',
  textual_note_with_target: 'Note textuelle avec cible',
  tool_selection: 'Sélection d’outil',
  unsupported_media_message: 'Le type de média de votre canvas actuel n\'est pas pris en charge par l\'éditeur d\'annotations.',
  useTemplate: 'Utiliser un modèle',
  video_annotation_instruction: 'Si vous souhaitez annoter des vidéos, vous devez installer le plugin Mirador Annotation Editor Video (MAEV) pour créer et modifier des annotations sur les vidéos :',
  your_tag_here: 'Votre étiquette',
  zoom: 'Zoom'
};
